module.exports = "/_next/static/images/transmissionEngineering-90adeae958404e8761d0aa1dd423209c.webp";